var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "columnRef",
      staticClass: "kanban-column",
      class: { "is-collapsed": _vm.isCollapsed },
    },
    [
      _vm.isCollapsed
        ? _c(
            "div",
            {
              staticClass: "collapsed-column",
              style: {
                background:
                  "linear-gradient(135deg, " +
                  _vm.color +
                  "20 0%, " +
                  _vm.color +
                  "40 100%)",
                borderColor: _vm.color + "60",
              },
              on: {
                click: function () {
                  return _vm.$emit("toggle-column", _vm.groupValue)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "collapsed-label", style: { color: _vm.color } },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.groupLabel) + "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collapsed-count",
                  style: {
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    color: _vm.color,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.totalCount || 0) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "collapsed-icon" }, [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    style: { color: _vm.color + "80" },
                  },
                  [_vm._v("chevron_right")]
                ),
              ]),
            ]
          )
        : _c("div", { staticClass: "expanded-column" }, [
            _c(
              "div",
              {
                staticClass: "column-header",
                style: { backgroundColor: _vm.color },
                on: {
                  click: function () {
                    return _vm.$emit("toggle-column", _vm.groupValue)
                  },
                },
              },
              [
                _c("h3", { staticClass: "column-title" }, [
                  _vm._v(_vm._s(_vm.groupLabel)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column-actions" }, [
                  _c("div", { staticClass: "count-badge" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.totalCount || _vm.contacts.length || 0) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "material-icons collapse-icon" }, [
                    _vm._v("chevron_left"),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "scrollContainerRef",
                staticClass: "contacts-container",
                style: {
                  "--column-color": _vm.color,
                  "--column-color-rgb": _vm.colorRgb,
                },
              },
              [
                !_vm.isVisible || !_vm.isLoaded
                  ? _c(
                      "div",
                      { staticClass: "skeleton-loading" },
                      _vm._l(3, function (i) {
                        return _c(
                          "div",
                          {
                            key: "skeleton-" + i,
                            staticClass: "skeleton-card",
                          },
                          [
                            _vm._m(0, true),
                            _vm._v(" "),
                            _c("div", { staticClass: "skeleton-message" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "skeleton-footer" }),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm.isLoading && _vm.contacts.length === 0
                  ? _c("div", { staticClass: "loading-state" }, [
                      _c("div", { staticClass: "spinner" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "loading-text" }, [
                        _vm._v(
                          _vm._s(_vm.$t("chat.kanbanContactList.loading"))
                        ),
                      ]),
                    ])
                  : _vm.contacts.length === 0
                  ? _c("div", { staticClass: "empty-state" }, [
                      _c("i", { staticClass: "material-icons empty-icon" }, [
                        _vm._v("inbox"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "empty-text" }, [
                        _vm._v(
                          _vm._s(_vm.$t("chat.kanbanContactList.emptyGroup"))
                        ),
                      ]),
                    ])
                  : _c(
                      "div",
                      { staticClass: "contacts-list" },
                      [
                        _vm._l(_vm.contacts, function (contact) {
                          return _c("ContactCard", {
                            key: contact._id,
                            attrs: {
                              contact: contact,
                              "is-selected":
                                _vm.selectedContactId === contact._id,
                              "current-time": _vm.currentTime,
                              "group-value": _vm.groupValue,
                            },
                            on: { click: _vm.handleContactClick },
                          })
                        }),
                        _vm._v(" "),
                        _vm.isLoading
                          ? _c("div", { staticClass: "loading-more" }, [
                              _c("div", { staticClass: "spinner-small" }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasMore && !_vm.isLoading
                          ? _c(
                              "div",
                              {
                                ref: "scrollTriggerRef",
                                staticClass: "scroll-trigger",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "load-more-btn",
                                    on: { click: _vm.handleLoadMore },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$t(
                                            "chat.kanbanContactList.loadMore"
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
              ]
            ),
          ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skeleton-header" }, [
      _c("div", { staticClass: "skeleton-avatar" }),
      _vm._v(" "),
      _c("div", { staticClass: "skeleton-info" }, [
        _c("div", { staticClass: "skeleton-line short" }),
        _vm._v(" "),
        _c("div", { staticClass: "skeleton-line" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }